import { IconButton } from "@circleco/compass/components/IconButton";

import { t } from "@/i18n-js/instance";

import { DOM_IDS } from "./Layout/defaults";
import { useCircleAIShellStore } from "./store/circleAIShellStore";

export const PanelCloseButton = () => {
  const setRightSidebarVisible = useCircleAIShellStore(
    s => s.setRightSidebarVisible,
  );
  const isRightSidebarVisible = useCircleAIShellStore(
    s => s.isRightSidebarVisible,
  );
  const ariaLabel = t("circle_ai_shell.close_panel");

  return (
    <IconButton
      icon="cross"
      size="sm"
      variant="outline"
      onClick={() => setRightSidebarVisible(false)}
      title={ariaLabel}
      aria-label={ariaLabel}
      aria-expanded={isRightSidebarVisible}
      aria-controls={DOM_IDS.communityRightSidebarBody}
      data-testid="circle-ai-shell-panel-close"
    />
  );
};

PanelCloseButton.displayName = "CircleAIAppShell.PanelCloseButton";
